import React, { useState, useEffect } from 'react';
import Logo from '../../../assets/videoPoster.png';
import { HELP_VIDEOS, SUPPORT_NUMBER } from './constants';
import styles from './HelpCenter.module.css';
import { operationsRegionClient } from 'clients';
import { AppState } from 'reducers/reducers';
import { connect } from 'react-redux';
import EmailIcon from 'components/Icons/EmailIcon';
import PhoneIcon from 'components/Icons/PhoneIcon';
import Loader from 'components/Loader/Loader';

type HelpCenterProps = ReturnType<typeof mapStateToProps>;
const HelpCenter = ({ profile }: HelpCenterProps) => {
    const [contactNumber, setContactNumber] = useState('');

    const fetchContactNumber = async (orgID: number) => {
        const response = await operationsRegionClient.getOrganizationOperationsRegion(orgID);
        setContactNumber(response.contact_number);
    };

    useEffect(() => {
        if (!profile) {
            return;
        }

        if (profile.affiliations.length === 0) {
            setContactNumber(SUPPORT_NUMBER);
            return;
        }

        fetchContactNumber(profile.affiliations[0].pk);
    }, [profile]);
    return (
        <div className={styles.container}>
            <div className={styles.row}>
                <div className={styles.cardContainer}>
                    <h3 className={styles.cardTitle}>
                        <EmailIcon height={24} width={24} /> Email
                    </h3>
                    <a href="mailto:partners@airgarage.com" className={styles.email}>
                        partners@airgarage.com
                    </a>
                    <span className={styles.cardFooter}>We'll reply as soon as possible</span>
                </div>
                <div className={styles.cardContainer}>
                    <h3 className={styles.cardTitle}>
                        <PhoneIcon height={24} width={24} /> Call
                    </h3>
                    {contactNumber ? <span className={styles.phone}>+1 {contactNumber}</span> : <Loader />}
                    <span className={styles.cardFooter}>Mon to Fri 7:00AM - 5:30PM PT</span>
                </div>
            </div>
            <h2 className={styles.sectionTitle}>Video Tutorials</h2>
            <div className={styles.grid}>
                {HELP_VIDEOS.map((video, index) => (
                    <div className={styles.item} key={index}>
                        <div className={styles.videoContainer}>
                            <video
                                className={styles.video}
                                width="320"
                                height="240"
                                controls
                                preload="none"
                                poster={Logo}
                            >
                                <source src={video.url} type="video/mp4" />
                                <track kind="captions" />
                            </video>
                        </div>
                        <h3 className={styles.itemTitle}>{video.title}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

function mapStateToProps(state: AppState) {
    return {
        profile: state.auth.profile,
    };
}

export default connect(mapStateToProps, {})(HelpCenter);
